import { AnyAction, Reducer } from 'redux';

export const STORE_MESSAGETYPE_SUPPORT = 'store/support-messagetype';
export const STORE_MESSAGES_SUPPORT = 'store/support-messages';
export const STORE_CASENO_SUPPORT = 'store/support-caseno';
export const STORE_REFMESSAGEID_SUPPORT = 'store/support-refmessageid';
export const STORE_SUPPORT_CREATESUPPORTATTMSG = 'store/support-createattachmentmsg';
export const STORE_SUPPORT_ATTACHMENTSUPPORTDATA = 'store/support-attachment-supportdata';
export const STORE_SUPPORT_DOCID = 'store/support-docid';
export const STORE_SUPPORT_ORDERNO = 'store/support-ticket-orderno';
export const STORE_SUPPORT_ORDERNO_DISABLED = 'store-disabled/support-ticket-orderno-disabled';
export const STORE_SUPPORT_EXPORT_DATA = 'store-export/support-ticket';

export interface AttachementSupportData {
    attachmentname: string;
    attachfilename: string;
}

export interface NewSupport {
    docid: string;
    dusername: string;
    supporttype: string;
    message: string;
    status: string;
    orderNo: string;
}

export interface SupportExportTickets {
    docid: string;
    dusername: string;
    supporttype: string;
    message: string;
    status: string;
    orderNo: string;
}

export interface SupportState {
    newSupport?: NewSupport;
    getAttachmentData?: AttachementSupportData[];
    querytype?: string;
    message?: string;
    caseno?: string;
    refmessageid?: string;
    messageFilesSupp: Array<File>;
    docid: string;
    orderNo: string;
    ordernoDisabled?: boolean;
    supportExportData?: SupportExportTickets[];
}

const initialState: SupportState = {
    newSupport: {
        docid: '',
        dusername: '',
        supporttype: '',
        message: '',
        status: '',
        orderNo: ''
    },
    querytype: '',
    messageFilesSupp: [],
    getAttachmentData: [],
    docid: '',
    orderNo: '',
    ordernoDisabled: false,
    supportExportData: [],
};

const reducer: Reducer<SupportState> = (state: SupportState = initialState, action: AnyAction): SupportState => {
    switch (action.type) {
        case STORE_MESSAGETYPE_SUPPORT:
            return {
                ...state,
                querytype: action.querytype
            };
        case STORE_MESSAGES_SUPPORT:
            return {
                ...state,
                message: action.message
            };
        case STORE_CASENO_SUPPORT:
            return {
                ...state,
                caseno: action.caseno
            };
        case STORE_REFMESSAGEID_SUPPORT:
            return {
                ...state,
                refmessageid: action.refmessageid
            };
        case STORE_SUPPORT_CREATESUPPORTATTMSG:
            return {
                ...state,
                messageFilesSupp: action.messageFilesSupp
            };
        case STORE_SUPPORT_ATTACHMENTSUPPORTDATA:
            return {
                ...state,
                getAttachmentData: action.getAttachmentData
            };
        case STORE_SUPPORT_DOCID:
            return {
                ...state,
                docid: action.docid
            };
        case STORE_SUPPORT_ORDERNO:
            return {
                ...state,
                orderNo: action.orderNo
            };
        case STORE_SUPPORT_ORDERNO_DISABLED:
            return {
                ...state,
                ordernoDisabled: action.ordernoDisabled
            };
        case STORE_SUPPORT_EXPORT_DATA:
            return {
                ...state,
                supportExportData: action.supportExportData
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/support.tsx